import { useState } from 'react'
import { getAllTimezones } from '../../utils/timezones'
import type { Timezone } from '../../utils/timezones'

export const useTimezones = () => {
  const [timezones] = useState<Timezone[]>(getAllTimezones())

  return timezones
}
